import React from "react";
import { InputNumber, Checkbox, Select, Alert } from "antd";
import { DatePickerItem } from "../../../../../Components/Items";

/**
 * Paso 1 — ejercicio, fecha de corte y, opcional, qué incidencias se descuentan de los días
 * trabajados. Los días se cuentan del 1 de enero (o del alta) a la fecha de corte.
 */
const PasoEjercicio = ({
  ejercicio, fechaCorte, descontarIncidencias, tiposIncidenciaIds, tiposIncidencia,
  soloLectura, onCambio,
}) => {
  const fueraDelEjercicio = fechaCorte && ejercicio && fechaCorte.year() !== Number(ejercicio);
  return (
    <div className="aguinaldo-paso">
      <div className="aguinaldo-titulo">Ejercicio y fecha de corte</div>
      <div className="aguinaldo-tenue aguinaldo-parrafo">
        Los días trabajados se cuentan del 1 de enero (o de la fecha de alta, si es posterior) a la
        fecha de corte, con el tope de días del año configurado para el aguinaldo.
      </div>

      <div className="aguinaldo-rejilla">
        <label className="aguinaldo-etiqueta">Ejercicio</label>
        <InputNumber
          value={ejercicio}
          min={2000}
          max={2100}
          disabled={soloLectura}
          onChange={(v) => onCambio({ ejercicio: v })}
          style={{ width: 140 }}
        />

        <label className="aguinaldo-etiqueta">Fecha de corte</label>
        <div>
          <DatePickerItem
            value={fechaCorte}
            disabled={soloLectura}
            onChange={(d) => onCambio({ fechaCorte: d || null })}
          />
          {fueraDelEjercicio && (
            <div className="aguinaldo-error-campo">La fecha de corte debe caer dentro del ejercicio.</div>
          )}
        </div>

        <label className="aguinaldo-etiqueta">Incidencias</label>
        <div>
          <Checkbox
            checked={descontarIncidencias}
            disabled={soloLectura}
            onChange={(e) => onCambio({ descontarIncidencias: e.target.checked })}
          >
            Descontar incidencias de los días trabajados
          </Checkbox>
          {descontarIncidencias && (
            <div style={{ marginTop: 8 }}>
              <Select
                mode="multiple"
                value={tiposIncidenciaIds}
                disabled={soloLectura}
                placeholder="Tipos de incidencia a descontar"
                style={{ width: "100%", maxWidth: 520 }}
                optionFilterProp="label"
                onChange={(v) => onCambio({ tiposIncidenciaIds: v })}
                options={(tiposIncidencia || []).map((t) => ({
                  value: t._id,
                  label: `${t.clave} — ${t.nombre}`,
                }))}
              />
              <div className="aguinaldo-tenue" style={{ marginTop: 4 }}>
                Se cuentan las incidencias capturadas en las prenóminas del ejercicio hasta la fecha
                de corte (sólo las medidas en días; un día cuenta una sola vez).
              </div>
              {descontarIncidencias && !(tiposIncidenciaIds || []).length && (
                <Alert
                  style={{ marginTop: 8, maxWidth: 520 }}
                  type="warning"
                  showIcon
                  message="Elige al menos un tipo de incidencia o desmarca la casilla."
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasoEjercicio;
